module.exports = "\r\n\r\nbody{\r\n    background-color: #262626;\r\n    height: 100vh;\r\n    color:white;\r\n}\r\n.fullscreen_image{\r\n  position:fixed;\r\n  height:100vh;\r\n  width:100%;\r\n}\r\n.container{\r\n  margin-left:20px;\r\n  margin-top: 50px;\r\n\r\n}\r\n.side_image{\r\n  max-width:35vw;\r\n  max-height:15vw;\r\n}\r\n.col{\r\ntext-align: center;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dual-meeting/dual-meeting.component.css
// module id = ./src/app/components/dual-meeting/dual-meeting.component.css
// module chunks = main